document.addEventListener("DOMContentLoaded", function () {
  const MIN_QTY = 100;
  const url = window.location.pathname;

  function showPopup(message) {
    alert(message);
  }

  function getQuantity() {
    const qtyInput = document.querySelector('input[name="quantity"]');
    if (!qtyInput) return 1;
    const qty = parseInt((qtyInput.value || "").trim(), 10);
    return isNaN(qty) ? 1 : qty;
  }

  function preventIfBelow(min, condition, message, event) {
    if (condition) {
      event.preventDefault();
      event.stopPropagation();
      showPopup(message);
    }
  }

  /* =========================
     1) MEDAILLES (bloc d'origine, inchangé)
     ========================= */
  if (url.includes("/products/medailles-en-bois-personnalisees")) {
  const form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return;

  const addBtn = form.querySelector('button[type="submit"], input[type="submit"]');
  if (!addBtn) return;

  addBtn.addEventListener("click", function (e) {
    const qty = getQuantity();

    // ✅ RÈGLE 1 : minimum 30 médailles (toujours)
    preventIfBelow(
      75,
      qty < 75,
      "Le minimum de commande pour les médailles est de 75 pièces.",
      e
    );

    // ✅ RÈGLE 2 : minimum 100 si quadrichromie cochée
    const ribbonCheckbox = document.querySelector(
      'input.cl-po--input[value="Personnalisés (impression quadrichromie)"]'
    );
    const isRibbonChecked = ribbonCheckbox?.checked;

    preventIfBelow(
      MIN_QTY,
      isRibbonChecked && qty < MIN_QTY,
      "Le minimum de commande pour des médailles avec rubans personnalisés est de 100 pièces.",
      e
    );
  });
}

  /* =========================
     2) RUBANS (min 100 toujours)
     ========================= */
  if (url.includes("/products/rubans-de-medailles-personnalises")) {
    const form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    const addBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!addBtn) return;

    addBtn.addEventListener("click", function (e) {
      const qty = getQuantity();

      preventIfBelow(
        MIN_QTY,
        qty < MIN_QTY,
        "Le minimum de commande pour des rubans personnalisés est de 100 pièces.",
        e
      );
    });
  }

  /* =========================
     3) CACHE-COU (min 100 toujours)
     ========================= */
  if (url.includes("/products/cache-cou-finisher-recompense-evenements-sportifs")) {
    const form = document.querySelector('form[action^="/cart/add"]');
    if (!form) return;

    const addBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!addBtn) return;

    addBtn.addEventListener("click", function (e) {
      const qty = getQuantity();

      preventIfBelow(
        MIN_QTY,
        qty < MIN_QTY,
        "Le minimum de commande pour les cache-cou finishers est de 100 pièces.",
        e
      );
    });
  }
});
